import { CONTACT_TYPE } from 'redux/slices/types';

export const isZipcodeIncluded = (contactType) => {
  const includeZipcode = [CONTACT_TYPE.publicDistrict, CONTACT_TYPE.multiple, CONTACT_TYPE.recruiterPro];

  return includeZipcode.includes(contactType);
};
